<template>
    <v-select 
        name="customer" 
        placeholder="Select Customer"
        v-model="highlighted"
        :options="customers"
        @input="onChange">
        <template slot="no-options">
            No data on this search..
        </template>
         <template #search="{attributes, events}">
            <input
            class="vs__search"
            :required="!highlighted"
            v-bind="attributes"
            v-on="events"
            />
        </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select';
export default {
    components: {
		vSelect
	},
    data() {
		return {
            customers : [],
			isLoading: false,
            searchItem: {},
            highlighted: null,
		}
	},
	props: {
		selected: {
			required: false,
        },
        onChange: {
            type: Function,
            required: false,
            default: (customer) => {},
        }
    },
    mounted(){
        this.getCustomer().then(() => {
            this.highlighted = this.selected;
        });
    },
    methods: {
        getCustomer(route = this.$route) {
			this.isLoading = true;

            return axios.get(`/customers/dropdown`).then(response => {
                response.data.map((obj) => {
                    this.customers.push( {label:obj.name, id: obj.id} ); 
                });
            }).catch(() => {
                this.$notify({
                    type: 'error',
                    title: 'Oops!',
                    text: 'Sorry, an error occured!'
                })
            }).finally(() => {
                this.isLoading = false;
            });
        },
        handleChange() {
            this.onChange(this.highlighted);
        }
    }
}
</script>

<style lang="less" scoped>
	.btn-link {
		font-weight: normal;
	}
	.btn-link:not(:hover) {
		color: #333;
	}
	.btn-link:active {
		box-shadow: none;
	}
</style>
